import { render } from "./Home.vue?vue&type=template&id=f338d630"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import PageTitle from "@/components/PageTitle.vue";
import AdminButton from "@/components/AdminButton.vue";
script.components = Object.assign({}, { PageTitle, AdminButton }, script.components);